"use client";

import FormInput from "../../../../components/FormInput";
import detailStyles from "../../css/inventoryItemDetail.module.css";

export default function StockRequestNoteRow({ note, setNote, readOnly = false }) {
  return (
    <div className={detailStyles.row}>
      <div className={detailStyles.field}>
        <FormInput
          label="Note"
          type="text"
          name="stockRequestNote"
          value={note}
          onChange={readOnly ? undefined : (e) => setNote(e.target.value)}
          readOnly={readOnly}
        />
      </div>
    </div>
  );
}
